<template>
  <el-dialog
    :title="'分配菜单权限 - ' + roleName"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div v-loading="loading" style="min-height: 200px;">
      <el-tree
        ref="menuTree"
        :data="menuTreeData"
        :props="defaultProps"
        show-checkbox
        node-key="id"
        :default-checked-keys="checkedKeys"
        :default-expand-all="true"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getMenuTree, getRoleMenus } from '@/api/menu'
import { assignMenus } from '@/api/role'

export default {
  name: 'AssignMenu',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleId: {
      type: [Number, String],
      default: null
    },
    roleName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      menuTreeData: [],
      checkedKeys: [],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.roleId) {
        this.getMenuData()
      }
    }
  },
  methods: {
    // 获取菜单树和角色已选菜单
    getMenuData() {
      this.loading = true
      Promise.all([
        getMenuTree(),
        getRoleMenus(this.roleId)
      ]).then(([menuRes, roleMenuRes]) => {
        this.menuTreeData = menuRes.data || []
        // 获取叶子节点ID（el-tree的checkedKeys只设置叶子节点）
        const roleMenuIds = roleMenuRes.data || []
        this.checkedKeys = this.getLeafIds(this.menuTreeData, roleMenuIds)
        this.$nextTick(() => {
          this.$refs.menuTree && this.$refs.menuTree.setCheckedKeys(this.checkedKeys)
        })
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    },

    // 获取叶子节点ID
    getLeafIds(tree, ids) {
      const leafIds = []
      const walk = (nodes) => {
        nodes.forEach(node => {
          if (!node.children || node.children.length === 0) {
            if (ids.includes(node.id)) {
              leafIds.push(node.id)
            }
          } else {
            walk(node.children)
          }
        })
      }
      walk(tree)
      return leafIds
    },

    // 获取所有选中的节点ID（包括半选的父节点）
    getAllCheckedKeys() {
      const checkedKeys = this.$refs.menuTree.getCheckedKeys()
      const halfCheckedKeys = this.$refs.menuTree.getHalfCheckedKeys()
      return [...checkedKeys, ...halfCheckedKeys]
    },

    // 提交保存
    handleSubmit() {
      const menuIds = this.getAllCheckedKeys()
      this.submitLoading = true
      assignMenus(this.roleId, menuIds).then(() => {
        this.$message.success('权限分配成功')
        this.dialogVisible = false
      }).catch(() => {}).finally(() => {
        this.submitLoading = false
      })
    },

    // 关闭弹窗
    handleClose() {
      this.menuTreeData = []
      this.checkedKeys = []
    }
  }
}
</script>
